function smbrefund(data, form) {
	if ('replaces' in data) {
		for (var replace in data.replaces) {
			// convert entities to html if needed
			if (data.replaces[replace].indexOf('&lt;') > -1) {
				var html = $('<div/>')
					.html(data.replaces[replace])
					.text();
			} else {
				var html = data.replaces[replace];
			}
			if (replace == 'form') {
				$('#form-content').replaceWith(html);
			} else if (replace.indexOf('#') === 0) {
				$(replace).replaceWith(html);
			}
		}
	}
}

$(function() {
	// $_ refers to jQuery added into Text file (WEBSITE-3647)
	if (typeof $_ !== 'undefined') {
		$ = $_;
	}

	$('#refundForm').load('smbrefund-form', function() {
		initAvastForm();
		$('#datepicker-date').datepicker('option', {
			maxDate: 0,
			dateFormat: 'mm/dd/yy'
		});

		$('#AVform *:input[type!=hidden]:first').focus();

		// DS TWEAKS
		[].forEach.call(document.querySelectorAll('.form-group input:not([type=submit]), .form-group textarea'), function(el) {
			el.classList.add('form-control');
		});
		[].forEach.call(document.querySelectorAll('.form-group select'), function(el) {
			el.classList.add('custom-select');
		});
		[].forEach.call(document.querySelectorAll('.form-group .button'), function(el) {
			el.classList.add('btn');
			el.classList.add('btn-primary');
		});

		var labels = document.querySelectorAll('.form-group .label');
		var i = labels.length;

		while (i--) {
			var label = labels.item(i);
			var text = label.textContent;
			var isRequired = label.parentNode.classList.contains('required');
			var nextElement = label.nextElementSibling.firstChild;

			if (nextElement) {
				// Aria
				nextElement.setAttribute('aria-label', text.replace(':', ''));
				if (isRequired) {
					nextElement.setAttribute('aria-required', true);
				}

				// Placeholder
				if (nextElement.tagName == 'SELECT') {
					nextElement.options[0].text = text;
				} else {
					nextElement.setAttribute('placeholder', text);
				}

				label.parentNode.removeChild(label);
			}
		}
	});

	$('input[name="type"]').change(function() {
		$('#primaryCategory')
			.val($(this).val())
			.change();
	});
	$('input[name="resellerProduct"], input[name="customerProduct"]').change(function() {
		$('#product').val($(this).val());
	});
	// removes banner, add class to budy inside android-mac-ios.js
	$('.radio-wrapper input').change(function() {
		var el = $('.' + $(this).data('show'));
		if (el.length) {
			$('.form-wrapper input').prop('checked', false);
			$('.form-wrapper, .refund-form-wrapper').addClass('hide');
			el.removeClass('hide');
		} else {
			$('.refund-form-wrapper').removeClass('hide');
		}
	});
});
